/**
 * 파트너 인증 API — Partner Authentication.
 * 계정은 어드민에서 발급하며 회원가입·비밀번호 재설정·refresh는 없다.
 */
import { createApiPath } from '@/shared/api/endpoints';
import { apiClient } from '@/shared/api/http-client';

/** POST /partner/auth/login 요청 */
export interface PartnerLoginRequest {
  /** 서버가 trim·소문자 변환 후 조회한다. 최대 255자 */
  loginEmail: string;
  /** 최대 128자 */
  password: string;
}

/** 로그인 파트너 계정 — 상단바 업체명·로그인 이메일 표시용 */
export interface PartnerAccount {
  accountId: number;
  partnerCompanyId: number;
  loginEmail: string;
  /** 계정 담당자명 */
  name: string;
  companyName: string;
}

/**
 * POST /partner/auth/login 응답.
 * 실패: 401 PARTNER_LOGIN_FAILED · 429 PARTNER_LOGIN_ATTEMPTS_EXCEEDED(5회 → 15분 차단)
 * · 403 PARTNER_ACCOUNT_SUSPENDED · 400 INVALID_PARAMETER(형식 오류)
 */
export interface PartnerLoginResponse extends PartnerAccount {
  /** 파트너 API 전용 access 토큰 */
  token: string;
  /** 토큰 유효 시간(초) */
  expiresIn: number;
}

/** GET /partner/auth/me 응답 */
export type PartnerMeResponse = PartnerAccount;

export const authService = {
  login: async (body: PartnerLoginRequest) => {
    const { data } = await apiClient.post<PartnerLoginResponse>(
      createApiPath.auth.login(),
      body,
    );
    return data;
  },

  /** 현재 토큰의 세션만 폐기한다(204). 다른 기기 세션은 유지된다. */
  logout: async () => {
    await apiClient.post(createApiPath.auth.logout());
  },

  me: async () => {
    const { data } = await apiClient.get<PartnerMeResponse>(
      createApiPath.auth.me(),
    );
    return data;
  },
};
